import { ConvertDetailPage } from "@/features/convert/pages/ConvertDetail";
import React from "react";

const ConvertDetail = () => {
  return <ConvertDetailPage />;
};

export default ConvertDetail;
